// Purpose: Capture emailed entry-review credentials before React or analytics render.
// Dependencies: Browser location/history only; no persistent browser storage.
// Behavior: Remove only the private entryReview fragment parameter and retain one
// valid token in memory, scoped to the exact event slug and entry document ID.

let capturedInvite = null;

export function captureEntryCandidateInvite() {
  if (typeof window === "undefined") return;
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  if (!fragment.has("entryReview")) return;

  const token = fragment.get("entryReview");
  const match = /^\/([^/]+)\/public_entry\/?$/.exec(window.location.pathname);
  const entryId = new URLSearchParams(window.location.search).get("entry");
  fragment.delete("entryReview");
  const remainder = fragment.toString();
  // Scrub malformed or wrong-route review credentials too. Do not leave them
  // available to later analytics, referrer readers, or copied browser URLs.
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}${remainder ? `#${remainder}` : ""}`);
  capturedInvite = null;
  if (!match || !entryId || entryId.length > 200 || entryId.includes("/") || !/^[a-f0-9]{64}$/.test(token || "")) return;
  try {
    const eventslug = decodeURIComponent(match[1]);
    if (eventslug.includes("/")) return;
    capturedInvite = { eventslug, entryId, token };
  } catch {
    // A malformed route must not authorize a different event or entry.
  }
}

export function getEntryCandidateInvite(eventslug, entryId) {
  return capturedInvite && capturedInvite.eventslug === eventslug && capturedInvite.entryId === entryId
    ? capturedInvite.token
    : "";
}
